module.exports = __webpack_public_path__ + "static/media/speech_icon.5dcf2cf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/configurator/speech_icon.png
// module id = 1514
// module chunks = 0